import React, { useContext, useEffect, useState, useMemo } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import axios from "axios";
import toast from "react-hot-toast";
import OpenDialogBox from "./OpenDialogBox";
import { GlobalVariablesContext } from "../../../GlobalVariables";
import TemplateModal, { TemplateDropdown } from "./TemplateModal";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import Email_Select_Modal from "../../../modals/Email_Select_Modal";
import Inbox from "../../../modals/Inbox";
import Reply_Email from "../../../modals/Reply_Email";
import Compose_Email from "../../../modals/Compose_Email";

// Calling components
import CallButton from "../CallButton/CallButton";
// CallStatusIndicator removed - replaced by global ActiveCallIndicator

function Header() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { currentUser, setCurrentUser, setIsMobileSidebarHidden } = useContext(GlobalVariablesContext);
  const [isShowTemplateDropdown, setIsShowTemplateDropdown] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { userData2 } = useContext(GlobalVariablesContext);
  const [resolving, setResolving] = useState(false);
  // -------------------------------------------------------------------------------
  const [selectedEmail, setSelectedEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [composEmail, setComposEmail] = useState("");
  const [open4, setOpen4] = useState(false);
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState("");
  const [replyEmail, setReplyEmail] = useState({});
  const [tracking_num, setTracking_num] = useState({});

  const [slected_num, setSelectedNum] = useState("");

  const [isFromNotification, setIsFromNotification] = useState(false);

  const recipientEmail = useMemo(() => {
    if (userData2 && userData2.orders && userData2.orders.length > 0) {
      const order = userData2.orders[0];
      return order.email || order.user_email || order.customer_email || "";
    }
    return "";
  }, [userData2]);

  useEffect(() => {
    if (userData2) {
      setTracking_num(userData2.orders.map((item) => item.tracking_number));
    }
    else {
      setTracking_num({})
    }
    const num =
      currentUser.phone.length >= 12
        ? currentUser.phone.slice(2)
        : currentUser.phone;
    setSelectedNum(num);
  }, [userData2, currentUser]);

  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
    setEmails([]);
  };

  const handleOpen = () => {
    setOpen(true);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
  };

  const handleSelectEmail = (emailAddr) => {
    // Just set the email and open the modal; Inbox component handles fetching.
    setEmail(emailAddr);
    setOpen2(true);
    setOpen(false);
    setOpen3(false);
  };

  const handleReply = (email) => {
    setOpen3(true);
    setOpen2(false);
    setReplyEmail(email);
  };

  const handleComposeEmail = (email, fromNotif = false) => {
    setOpen(false);
    setOpen2(false);
    setOpen4(true);
    setSelectedEmail(email);
    setIsFromNotification(fromNotif);
  };
  // Modals and functions END

  // -------------------------------------------------------------------------------

  const handleBackBtn = () => {
    if (window.innerWidth < 700 && window.history.state && window.history.state.chatActive === true) {
      window.history.back();
    } else {
      setIsMobileSidebarHidden(false);
      setCurrentUser(null);
    }
  };


  const handleResolveHandover = async () => {
    if (!currentUser?.phone) return;
    setResolving(true);
    try {
      await axios.post('https://casualfootwears.com/api/resolve_handover/', {
        session_id: currentUser.phone
      });
      toast.success('Handover resolved ✓', { style: { fontSize: '13px' } });
      // Remove handover_data from currentUser so UI updates immediately
      setCurrentUser(prev => ({ ...prev, handover_data: null, human_needs_action: false }));
    } catch (err) {
      console.error('Failed to resolve handover:', err);
      toast.error('Failed to resolve handover', { style: { fontSize: '13px' } });
    } finally {
      setResolving(false);
    }
  };

  const NUMBER_TAGS = {
    "919468063603": "LD",
    "918278244128": "LDS",
    "919485998901": "LTS",
    "919485998902": "LT",
    "919485998903": "AMD",
    "919485998904": "AMDI",
    "919485998905": "OLS",
    "919485998906": "OL",
    "919485998907": "LS",
    "919485998908": "TLS",
    "919485998909": "TL",
    "919485998910": "SS",
    "919485904987": "LTF",
    "919485904988": "LDF",
    "919485972920": "LMI",
    "919485972921": "LMO",
    "919499240313": "FS",
    "919485987613": "MLS",
    "919466022393": "LLS",
    "918278244127": "LD",
    "918278244130": "LTS",
    "918278244131": "LT",
    "918278244132": "AMC",
  };

  const fromWhere = (num) => {
    const cleanNum = String(num || '').replace(/\D/g, '');
    const key = cleanNum.length === 10 ? '91' + cleanNum : cleanNum;
    return NUMBER_TAGS[key] || "LD";
  };

  return (
    <>
      {selectedTemplate && (
        <TemplateModal
          template={selectedTemplate}
          currentUser={currentUser}
          onClose={() => setSelectedTemplate(null)}
        />
      )}

      <div className="leftOfHeader">
        <button className="openDialogBtn arrowBtn" onClick={handleBackBtn}>
          <ArrowBackIcon />
        </button>

        <button className="openDialogBtn" onClick={() => setIsDialogOpen(true)}>
          Open Dialog
        </button>

        {isDialogOpen && <OpenDialogBox setIsDialogOpen={setIsDialogOpen} />}

        <div className="Chat__headerinfo">
          <h3 id="chat_name">
            {currentUser ? (
              `${currentUser.name} (${currentUser.phone.slice(2)}) [${fromWhere(
                currentUser.wb_num
              )}]`
            ) : (
              <span>LOADING...</span>
            )}
          </h3>
        </div>
      </div>

      <div className="Chat__headerright">
        {/* Call Status Indicator moved to global ActiveCallIndicator */}

        {/* Call Button - initiate call to current user */}
        <CallButton />


        {/* Resolve Handover Button - only shown when this chat has active handover */}
        {currentUser?.human_needs_action && (
          <button
            onClick={handleResolveHandover}
            disabled={resolving}
            title="Mark handover as resolved"
            style={{
              marginRight: '8px',
              marginLeft: '8px',
              border: 'none',
              background: resolving ? '#ccc' : 'linear-gradient(135deg, #ff6b35, #e65100)',
              borderRadius: '6px',
              padding: '8px 12px',
              color: 'white',
              fontWeight: 'bold',
              cursor: resolving ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '0.8rem',
              boxShadow: '0 2px 6px rgba(255,107,53,0.4)',
            }}
          >
            <CheckCircleIcon style={{ fontSize: '16px' }} />
            {resolving ? 'Resolving...' : 'Resolve'}
          </button>
        )}

        <button
          onClick={handleOpen}
          style={{
            marginRight: "30px",
            marginLeft: "12px",
            border: "none",
            backgroundColor: "#90EE90",
            borderRadius: "5px",
            padding: "12px 12px",
            color: "black",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Notification
        </button>
        <Email_Select_Modal
          slected_num={slected_num}
          open={open}
          handleSelectEmail={handleSelectEmail}
          handleClose={handleClose}
          handleComposeEmail={handleComposeEmail}
        />
        <Inbox
          open2={open2}
          handleClose={handleClose}
          handleBack={handleOpen} // Go back to Email List
          handleOpenReply={handleReply}
          handleCompose={handleComposeEmail}
          isDarkMode={false} // Header doesn't have dark mode state currently
          selectedEmail={email}
        />
        <Reply_Email
          open3={open3}
          slected_num={slected_num}
          tracking_num={tracking_num}
          email={replyEmail}
          selectedEm={email}
          setOpen3={setOpen3}
          handleSelectEmail={handleSelectEmail}
        />
        <Compose_Email
          open4={open4}
          slected_num={slected_num}
          handleOpen={handleOpen}
          email={selectedEmail}
          setOpen4={setOpen4}

          tracking_num={tracking_num}
          recipientEmail={recipientEmail}
          isFromNotification={isFromNotification}
          templateData={userData2?.orders?.[0]}
        />
        <div className={`tm-trigger-wrapper${isShowTemplateDropdown ? ' dropdown-open' : ''}`}>
          <button
            className="tm-trigger-btn"
            onClick={() => setIsShowTemplateDropdown(!isShowTemplateDropdown)}
            title="Send WhatsApp Template"
          >
            <LibraryBooksIcon />
          </button>
          {isShowTemplateDropdown && (
            <TemplateDropdown
              onSelect={(template) => setSelectedTemplate(template)}
              onClose={() => setIsShowTemplateDropdown(false)}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
